import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('unsaved_changes'),
    description: defineMessage('there_are_unsaved_chang_hem_or_continue_editing'),
    cancelButtonText: defineMessage('continue_editing_1'),
    confirmButtonText: defineMessage('discard_changes_1'),
};
